import { config } from 'affiny-core/env';
import { ISpecialOffer } from 'affiny-core/modules/api/models/payment/eligible-categories.types';
import {
  getCurrentSpecialOffer,
  getPaymentWebviewUrlWithSpecialOffer,
} from 'affiny-core/modules/api/repositories/payment/payment.sagas';
import { IPaymentUrlSpecialOffer } from 'affiny-core/modules/api/repositories/payment/payment.types';
import { handleAsyncStatus } from 'affiny-core/modules/asynchronousState/saga';
import { EAsyncEventTypes } from 'affiny-core/modules/asynchronousState/types';
import { ActionsOfType } from 'affiny-core/modules/helpers';
import { specialOfferActions } from 'affiny-core/modules/specialOffer/actions';
import {
  selectCurrentSpecialOffer,
  selectCurrentSpecialOfferCallDone,
} from 'affiny-core/redux/selectors/specialOfferSelectors';
import { selectIsSub } from 'affiny-core/redux/selectors/subscriptionsSelectors';
import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import { ESpecialOffersActionType, TSpecialOffersAction } from './actions';
import { ISpecialOfferState } from '../specialOffer/reducer';

export function* getCurrentSpecialOfferSaga() {
  if (yield select(selectIsSub)) return;

  if (yield select(selectCurrentSpecialOfferCallDone)) return;

  const currentSpecialOffer: ISpecialOffer | undefined = yield call(
    getCurrentSpecialOffer
  );

  yield put(specialOfferActions.getCurrentSpecialOfferCallDone());

  if (!currentSpecialOffer) return;

  const { type, startDate, endDate } = currentSpecialOffer;

  yield put(
    specialOfferActions.getCurrentSpecialOfferSuccess({
      type,
      startDate,
      endDate,
      paymentUrl: '',
    })
  );
}

export function* goToRateCardSO({
  payload: { actionCode, returnRouteOk, returnRouteKo },
}: ActionsOfType<
  TSpecialOffersAction,
  ESpecialOffersActionType.GET_PAYMENT_URL_FOR_SO
>) {
  const { origin } = config.env;
  const specialOffer: ISpecialOfferState = yield select(
    selectCurrentSpecialOffer
  );

  if (specialOffer.type) {
    /* BEGIN: Preprod hack
Explanation: Payment team on a security issue has filtered the origin of returnUrlOk and returnUrlKo for apixl but not for juno.
So, we call payment with prod parameters.
Result: We can go to the payment page, but if we come back by back button, we comes back in production.
This hack could be removed when we don't use preprod anymore */
    const rewritedOrigin = origin?.replace('.pprod', '');
    /* END: Preprod hack */
    const paymentUrlResponse: IPaymentUrlSpecialOffer['attributes'] = yield call(
      getPaymentWebviewUrlWithSpecialOffer,
      specialOffer.type,
      {
        actionCode,
        returnUrlOk: `${rewritedOrigin}${returnRouteOk}`,
        returnUrlKo: `${rewritedOrigin}${returnRouteKo}`,
      }
    );

    if (!paymentUrlResponse.isValid) return;

    yield put(
      specialOfferActions.redirectToSpecialOfferPaymentPage({
        paymentSoUrl: paymentUrlResponse.url,
      })
    );
  }
}

export function* specialOffersRootSaga() {
  yield all([
    takeLatest(
      ESpecialOffersActionType.GET_CURRENT_SPECIAL_OFFER,
      handleAsyncStatus(
        getCurrentSpecialOfferSaga,
        EAsyncEventTypes.GET_SPECIAL_OFFER
      )
    ),
    takeLatest(
      ESpecialOffersActionType.GET_PAYMENT_URL_FOR_SO,
      handleAsyncStatus(
        goToRateCardSO,
        EAsyncEventTypes.GET_SPECIAL_OFFER_WITH_ACTION_CODE
      )
    ),
  ]);
}
